module.exports = __webpack_public_path__ + "img/13.195cc90b.jpg";